<div class="page-container rep-review-detail-container container pt-2">
  <h1 class="header col-12 mb-1">
    Financial Pro. Details - {{ repDetail ? repDetail.RepID : '' }}
  </h1>
  @if (!loading) {
    <div class="actions-container mb-3">
      <button
        type="button"
        mat-button
        color="primary"
        (click)="nav('rep-review')"
      >
        <mat-icon>arrow_back_ios</mat-icon> Back to Financial Pro. Monitor
      </button>
    </div>

    <div class="trade-info-container info-card mb-4 w-100 p-0">
      <div class="card-header">
        <span class="card-title-container">
          <mat-icon
            class="scoreclass-icon mr-2 {{ repDetail.ScoreClass }}"
            [matTooltip]="'Rep Score: ' + repDetail.ScoreClass"
          >
            {{ scoreClassKey[repDetail.ScoreClass] }}
          </mat-icon>
          Rep Code:
          <span class="card-title mb-0 ms-2">
            {{ repDetail.RepID }}
          </span>
        </span>

        @if (!rights.includes('PostTradeReadOnly')) {
          <span>
            <app-approval-menu
              [recordStatus]="repDetail.ReviewStatus"
              [recordType]="'rep'"
              (toggleStatus)="toggleReviewed($event)"
            />
          </span>
        }
      </div>
      <div class="card-info row">
        @for (repInfo of repInfoKey; track repInfo.label) {
          @if (
            (repDetail && repDetail[repInfo.varName]) ||
            (repInfo.key && repInfo.key[repDetail[repInfo.varName]])
          ) {
            <app-card-infopoint
              class="col-sm-3 col-12"
              [datapoint]="repInfo"
              [dataset]="repDetail"
            />
          } @else if (
            repInfo.varSet &&
            repDetail.Details[repInfo.varSet] &&
            repDetail.Details[repInfo.varSet][repInfo.varName]
          ) {
            <app-card-infopoint
              class="col-sm-3 col-12"
              [datapoint]="repInfo"
              [dataset]="repDetail.Details"
            />
          }
        }
      </div>
    </div>

    @if (rights.includes('CM') && aiSummary.length > 0) {
      <div class="info-card mb-4">
        <div class="card-header">
          <span class="card-title mb-0"> AI Transaction Summary </span>
        </div>
        <div class="card-info row">
          <div class="notes-list px-3" [innerHTML]="aiSummary"></div>
          <div class="ai-disclaimer px-3 pt-3 w-100">
            <span>
              **This is created by generative AI. Results and details should be
              verified.
            </span>
          </div>
        </div>
      </div>
    }

    @if (repDetail?.Details?.bridges) {
      <div class="alerts-container info-card mb-4">
        <div class="card-header">
          <span class="card-title mb-0"> Alerts </span>
        </div>
        <div class="card-info row">
          <div class="alerts">
            @for (bridge of repDetail.Details.bridges; track bridge) {
              @if (ptSvc.bridgeHasAlerts(bridge.trueRules)) {
                <app-reason-text
                  class="col-6"
                  [data]="bridge.trueRules"
                  [defaultView]="'list'"
                />
              } @else {
                <div class="no-data no-alerts w-100">No Alerts Found</div>
              }
            }
          </div>
        </div>
      </div>
    }

    @if (repDetail?.Details?.FPMetrics) {
      <div class="key-metrics-container info-card mb-4">
        <div class="card-header">
          <span class="card-title mb-0"> Key Metrics </span>
        </div>
        <div class="card-info row">
          @for (keyMetric of keyMetricsKey; track keyMetric.label) {
            @if (
              repDetail.Details.FPMetrics[keyMetric.varName] ||
              keyMetric.varName === 'NewAccountsCount'
            ) {
              <app-card-infopoint
                class="col-sm-3 col-12"
                [datapoint]="keyMetric"
                [dataset]="repDetail.Details.FPMetrics"
              />
            }
          }
        </div>
      </div>
    }

    <div class="info-card mb-4">
      <div class="card-header">
        <span class="card-title mb-0">Actions</span>

        @if (!rights.includes('PostTradeReadOnly')) {
          <span>
            <app-approval-menu
              [recordStatus]="repDetail.ReviewStatus"
              [recordType]="'rep'"
              (toggleStatus)="toggleReviewed($event)"
            />
          </span>
        }
      </div>
      <div class="actions-card">
        <div class="custom-tabs">
          <mat-tab-group [selectedIndex]="selectedActionTab">
            <mat-tab label="Notes & Attachments">
              <app-attachments-widget
                [tradeId]="repId"
                [tradeDetail]="repDetail"
                [widgetType]="'rep'"
                [readOnly]="rights.includes('PostTradeReadOnly')"
              />
            </mat-tab>

            <mat-tab label="Review Status History">
              <app-expanding-table
                [dataset]="repDetail.RepApprovalHistory"
                [evalKey]="repReviewKey"
              />
            </mat-tab>

            @if (rights.includes('CM')) {
              <mat-tab label="Case History">
                @if (!rights.includes('PostTradeReadOnly')) {
                  <div class="mb-2 pt-2 initiate-case-container">
                    <button
                      type="button"
                      mat-raised-button
                      color="primary"
                      class="w-50"
                      [disabled]="!this.repDetail.RepID"
                      (click)="initiateCase()"
                    >
                      <mat-icon>medical_services</mat-icon> Initiate Case
                    </button>
                  </div>
                }

                <app-expanding-table
                  [dataset]="caseHistory"
                  [evalKey]="caseHistoryKey"
                  [actionColumn]="{
                    link: 'case-management/case-manager/',
                    selector: 'CRID',
                    tooltip: 'Review Case',
                    icon: 'rate_review',
                    external: true,
                  }"
                />
              </mat-tab>
            }
          </mat-tab-group>
        </div>
      </div>
    </div>

    @if (
      repDetail.Details.RepHistory && repDetail.Details.RepHistory.length > 0
    ) {
      <div class="mutual-funds-container info-card mb-4">
        <div class="card-header">
          <span class="card-title mb-0"> Financial Pro. Review History </span>
        </div>
        <app-expanding-table
          [dataset]="repDetail.Details.RepHistory"
          [evalKey]="repHistoryKey"
        />
      </div>
    }

    @if (repDetail.Details.DisplayFX?.ShowTradeHistory) {
      <div class="mutual-funds-container info-card mb-4">
        <div class="card-header">
          <span class="card-title mb-0"> Transaction History </span>
        </div>
        <app-expanding-table
          [dataset]="repDetail.Details.TradeHistoryFiltered"
          [evalKey]="tradeHistoryKey"
          [actionColumn]="{
            link: 'trade-review/',
            selector: 'TradeID',
            tooltip: 'View Transaction',
            icon: 'launch',
            external: true,
          }"
        />
      </div>
    }

    @if (repDetail?.Details?.DisplayFX?.ShowClientAccounts) {
      <div class="mutual-funds-container info-card mb-4">
        <div class="card-header">
          <span class="card-title mb-0"> All Client Accounts </span>
        </div>
        <app-expanding-table
          [dataset]="repDetail.Details.AllAccountsDisplay"
          [evalKey]="allClientAccountsKey"
        />
      </div>
    }

    <div class="mutual-funds-container info-card mb-4">
      <div class="card-header">
        <span class="card-title mb-0"> All Client Holdings </span>
      </div>

      @if (
        chartOptions &&
        (repDetail.Details.Chart_AllClient_PT ||
          repDetail.Details.Chart_AllClient_Reg ||
          repDetail.Details.Chart_AllClient_Family) &&
        repDetail.Details.DisplayFX?.['ShowClientPositionsTabFX']
      ) {
        <div class="px-4 pt-3 holdings-visual-container">
          <div>
            <mat-form-field class="me-2">
              <mat-label>Filter Type</mat-label>
              <mat-select
                [value]="chartSelection"
                (selectionChange)="changeChartSelection($event)"
              >
                <mat-option [value]="'PT'"> Product Type </mat-option>
                <mat-option [value]="'Reg'"> Account Registration </mat-option>
                <mat-option [value]="'Family'"> Fund Family </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="chart-container clearfix mb-2">
            @if (showChart() === 'hide') {
              <div class="no-data">No chart available</div>
            }
            <div class="chart px-4 col-6 {{ showChart() }}">
              <highcharts-chart
                [Highcharts]="Highcharts"
                [options]="chartOptions"
                [(update)]="updateFlag"
              />
            </div>
          </div>
        </div>
      } @else {
        <div class="actions-card">
          <div class="no-data"> No holdings data to display </div>
        </div>
      }
    </div>
  }

  <ngx-loading [show]="loading" />
</div>
